import F2AppclassFactory from '../utils/f2AppclassFactory';
import Component from '../components/apps/profile';

F2AppclassFactory.create({
  Component,
  appId: 'profile',
  contextProperties: ['channel', 'mpTicker', 'templateOverride', 'ticker', 'urlDomain', 'urlPrefix', 'xid', 'yyy']
});
